module.exports = __webpack_public_path__ + "img/social_3.79a1f6ab.svg";